import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // Başlangıçta null, yüklenme durumunu gösterir
    const userData = JSON.parse(localStorage.getItem('user_data')); // Oturum verilerini `localStorage`'dan al

    useEffect(() => {
        const checkToken = async () => {
            if (userData && userData.token) {
                try {
                    // Backend'e token doğrulama isteği gönder
                    const response = await axios.post(`${config.API_BASE_URL_V1}auth/check`, {}, {
                        headers: {
                            Authorization: `Bearer ${userData.token}`, 
                    },
                    });
                    if (response.status === 200) {
                    setIsAuthenticated(true); // Başarılı yanıt durumunda kullanıcı doğrulanmış olur
                    }
                } catch (error) {
                    console.error('Token doğrulama hatası:', error.response?.data || error.message);
                    setIsAuthenticated(false);
                }
            } else {
                setIsAuthenticated(false);
            }
        };

        checkToken();
        }, []);

  if (isAuthenticated === null) {
    return (
        <div id="loader-wrapper">
            <div id="loader">
                <span className="loader-line"></span>
            </div>
        </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};
export default ProtectedRoute;
